import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f748262"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"margin-top":"10em","margin-bottom":"12em"} }, "Diapason of Fate", -1))
const _hoisted_2 = {
  key: 0,
  class: "single"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { style: {"margin-top":"10em","margin-bottom":"6em"} }, " Thanks for playing, have a nice day. ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "credits dys-letter",
    id: "creditsContainer",
    onWheel: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.manualScroll && _ctx.manualScroll(...args))),
    style: _normalizeStyle(
      _ctx.isShown
        ? 'background: black;'
        : 'display:none; background: transparent; color: transparent; pointer-events: none; overflow: hidden'
    )
  }, [
    _createElementVNode("div", {
      class: "go-back",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onCreditsClose())),
      style: _normalizeStyle(_ctx.isShown ? '' : 'color: transparent')
    }, " Go back ", 4),
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (element, heading) => {
      return (_openBlock(), _createElementBlock("div", { key: heading }, [
        _createElementVNode("h2", null, _toDisplayString(heading), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element, (elem, elementName) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "heading-container",
            key: elementName
          }, [
            ((elementName as string).includes('SINGLE'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (elem.indexOf('|') !== -1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "credit-link",
                        style: _normalizeStyle(_ctx.isShown ? '' : 'color: transparent'),
                        href: elem.substring(elem.indexOf('|') + 1)
                      }, _toDisplayString(elem.substring(0, elem.indexOf("|"))), 13, _hoisted_3))
                    : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(elem), 1))
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(elementName), 1),
                  _createElementVNode("span", _hoisted_7, [
                    (elem.indexOf('|') !== -1)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "credit-link",
                          style: _normalizeStyle(_ctx.isShown ? '' : 'color: transparent'),
                          href: elem.substring(elem.indexOf('|') + 1)
                        }, _toDisplayString(elem.substring(0, elem.indexOf("|"))), 13, _hoisted_8))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(elem), 1))
                  ])
                ]))
          ]))
        }), 128))
      ]))
    }), 128)),
    _hoisted_10,
    _createElementVNode("div", {
      style: _normalizeStyle(`margin-top: 3em; color: lightgray; margin-left: 20%; margin-right: 20%; transition: color 1s; ${
        _ctx.isShown ? '' : 'color: transparent'
      }`)
    }, " 2023 No copyright. Most of the assets used in this game are taken from internet without any authorization. If you want something to be removed, contact me on discord @leco4002. This is just for fun, I don't make any money with this. ", 4),
    _hoisted_11
  ], 36))
}